import React, { ReactNode } from "react";
import cn from "classnames";
import styles from "./Sidebar.module.scss";

export default function SidebarDisclosure({
  open,
  className,
  children,
}: {
  open: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      ref={(node) => node?.toggleAttribute("inert", !open)}
      aria-hidden={!open}
      className={cn(
        className,
        styles.disclosure,
        open && styles.disclosure_open,
      )}
    >
      <div className={styles.disclosure__inner}>{children}</div>
    </div>
  );
}
